import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/v1/product-locations', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/v1/product-locations', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/v1/product-locations/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const assignMultipleWarehouse = data => {
  return httpClient
    .post('/api/v1/product-locations/multile-warehouses', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getLocation = (Options = {}) => {
  return httpClient
    .get('/api/v1/product-locations/locations', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getProduct = (Options = {}) => {
  return httpClient
    .get('/api/v1/product-locations/products', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const category = (Options = {}) => {
  return httpClient
    .get('/api/v1/product-locations/categories', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const deleteMultiple = data => {
  return httpClient
    .post('/api/v1/product-locations/multiple-deletes', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const group = (categoryId, Options = {}) => {
  return httpClient
    .get(`/api/v1/product-locations/groups/${categoryId}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  store,
  getLocation,
  getProduct,
  assignMultipleWarehouse,
  destroy,
  category,
  deleteMultiple,
  group
}
